import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { PcmpProjectCreatePage } from '@/features/pcmp/pages/PcmpProjectCreatePage';

export const Route = createFileRoute('/_auth/pcmp/projects/new')({
  component: () => (
    <ErrorBoundary moduleName="Create PCMP Project">
      <Suspense fallback={<PageLoader />}>
        <PcmpProjectCreatePage />
      </Suspense>
    </ErrorBoundary>
  ),
});
